
  import { computed, defineComponent, ref } from "vue";
  import Temporizador from "./Temporizador.vue";
  import { useStore } from 'vuex'
  import { key } from '@/store'
  export default defineComponent({
    name: "FormularioFormulario",
    emits: ['aoSalvarTarefa'],
    components: {
      Temporizador,
    },
    setup(props, { emit }) {
        const store =  useStore(key)

        const descricao = ref("")
        const idProjeto = ref("")

        const projetos = computed(() => store.state.projeto.projetos)

        const finalizarTarefa = (tempoDecorrido:number): void => {
            emit('aoSalvarTarefa',{
                duracaoEmSegundos:tempoDecorrido,
                descricao: descricao.value,
                projeto: projetos.value.find(proj => proj.id == idProjeto.value)
            })
            descricao.value =''
        }
    
        return{
            descricao,
            idProjeto,
            projetos,
            finalizarTarefa,
        }

    }
});

